export enum ModalSize {
  Small,
  Medium,
  Large,
  None,
}
